import moment from 'moment';
import { DashboardCommissionsRowProps } from './DashboardCommissionsInvoicesRow.types';
import { ChangeEvent, MouseEvent, useCallback, useRef } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import {
  UPLOAD_INVOICE_QUERY_KEY,
  uploadInvoiceQuery,
} from '../DashboardCommissionsInvoices.query';
import { ReactComponent as DownloadIcon } from '../../../../../../assets/vectors/download.svg';
import Button from '../../../../../designSystem/Button/Button';
import { ButtonSize } from '../../../../../designSystem/Button/Button.types';
import { Invoice } from '../../../../../../types/models/invoice/invoice.types';
import { useNavigate } from 'react-router-dom';

export default ({ commissionInvoice, ...props }: DashboardCommissionsRowProps) => {
  const { month, year, total_amount, has_invoice, invoice } = commissionInvoice;

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const inputRef = useRef<HTMLInputElement>(null);

  const { mutate, isLoading: isInvoiceUploading } = useMutation<Awaited<any>, Error, FormData>(
    (data) => uploadInvoiceQuery(data),
    {
      mutationKey: UPLOAD_INVOICE_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0)
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onFileChangeCapture = (e: ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    const { files } = e.target;
    const formData = new FormData();
    if (files) {
      formData.append('month', month.toString());
      formData.append('year', year.toString());
      // @ts-ignore
      for (const file of files) {
        formData.append('files', file);
      }
      mutate(formData);
    }
  };

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const getContentByStatus = useCallback(() => {
    const isCurrentMonth = `${month}-${year}` === moment().format('M-Y');
    if (!isCurrentMonth) {
      if (has_invoice) {
        switch ((invoice as Invoice).id_status) {
          case 2:
            return 'En attente de paiement';
          case 3:
            return `Payée le ${moment(invoice?.paid_at)
              .locale('fr')
              .format('DD/MM/YYYY à HH:mm')}`;
        }
      } else {
        return (
          <>
            <input
              ref={inputRef}
              type="file"
              multiple
              hidden
              onChangeCapture={onFileChangeCapture}
            />
            <Button
              startIcon={DownloadIcon}
              size={ButtonSize.Small}
              onClick={onClick}
              isLoading={isInvoiceUploading}>
              Déposer une facture
            </Button>
          </>
        );
      }
    } else {
      return '';
    }
  }, [inputRef]);

  return (
    <tr onClick={(e) => {
      e.stopPropagation()
      navigate(`${month}/${year}`)
    }} {...props}>
      <td>{moment(`${month}-${year}`, 'M-Y').locale('fr').format('MMMM YYYY')}</td>
      <td>{(total_amount / 100).toFixed(2)}€</td>
      <td onClick={e => e.stopPropagation()}>{getContentByStatus()}</td>
    </tr>
  );
};
